import { useState,useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
const GA_MEASUREMENT_ID = 'G-R1VGHFCXH0';
const Cookie = () => {
    const [accepted, setAccepted] = useState(null);

    useEffect(() => {
      const consent = Cookies.get('cookieConsent');

      if (consent === 'true') {
        setAccepted(true);

        // Initialize GA only if accepted
        ReactGA.initialize(GA_MEASUREMENT_ID);
        ReactGA.send('pageview');

      } else if (consent === 'false') {
        setAccepted(false);
      }
    }, []);

  useEffect(() => {
    const banner = document.querySelector('.gdpr-cookie-banner');

    if (banner && accepted === null) {
      document.body.style.paddingBottom = banner.offsetHeight + 'px';
    } else {
      document.body.style.paddingBottom = '0px';
    }

    return () => {
      document.body.style.paddingBottom = '0px';
    };
  }, [accepted]);

  const handleAccept = () => {
    Cookies.set('cookieConsent', 'true', { expires: 365, path: '/' });
    setAccepted(true);

    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send('pageview');
  };

  const handleReject = () => {
    Cookies.set('cookieConsent', 'false', { expires: 365, path: '/' });
    setAccepted(false);
  };

  if (accepted !== null) return null;
    return (
        <>
            <section data-section-theme="black-bold" aria-label="Cookie banner" className="gdpr-cookie-banner BOTTOM black-bold bar full-styling d-flex flex-wrap gap-0 gap-sm-3">
                <p className="disclaimer-text sqs-cookie-banner-v2-text">We use cookies to enhance your experience and keep our site running smoothly. By using this site, you agree.</p>
                <div className="button-group sqs-cookie-banner-v2-cta-container d-flex gap-2">
                    <button
                      className="sqs-reject-element--primary"
                      onClick={handleReject}
                    >
                      <span>Reject</span>
                    </button>
                    <button className="accept sqs-button-element--primary sqs-cookie-banner-v2-accept sqs-cookie-banner-v2-cta" onClick={handleAccept}><span>Accept</span></button>
                </div>
            </section>
        </>
    );
};

export default Cookie;
